<template>
    <div class="sidebar-content">
        <div class="midblock">
          <div class="padding20 showonmobile" style="display:none;">
            <div class="font14 bold width100 margintop20 marginbottom30 ">
                    <span
                        class="darkblue"
                        v-html="cruise.bestemming_naam + ' Cruise'"
                    ></span
                    ><br />
              <small class="darkblue font11"
              >met {{ cruise.schip_naam }}</small
              >
            </div>
            <div v-bind:class="{
            show: isMobile,
            hide: !isMobile}"
                 v-on:click="mobileShown = !mobileShown"
style="margin-left:auto;"
            >
              <span style="background: #2078b3;color:white; padding: 6px 5px; border-radius:5px; display: block;margin-block:10px;text-align: center;font-weight: bold; line-height: 13px;font-size:13px;position: relative">
                <span v-if="totalPrice > 0 && showPrice">
                   <small style="font-size:11px;font-weight: normal">totaal</small><br>
                  &euro;
                {{  roundPrice(totalPrice) }}
                </span>
                <span v-else-if="payload.cabins[0].cabinType && lowestRateForCabinType(payload.cabins[0].cabinType)">
                  <small style="font-size:11px;font-weight: normal">vanaf</small>
                <br>&euro;
                  {{
                    roundPrice(
                        lowestRateForCabinType(payload.cabins[0].cabinType).apiData
                            .prijs / payload.cabins[0].volwassenen
                    )
                  }}
                  <small style="font-size:11px;font-weight: normal">p.p.</small>
                </span>
                 <font-awesome-icon :icon="mobileShown ? 'chevron-up' : 'chevron-down'" style="position: absolute;right:5px;top:5px;"/></span>
              </div>
          </div>
          <div v-bind:class="{
            show: !isMobile || mobileShown,
            hide: isMobile && !mobileShown}"
               >
          <div class="flexmobile">
            <div>
                <img
                    :src="cruise.schip_img"
                    class="width100 sidebarHeaderImage"
                />
                <div
                    class="sideBarRederijLogo"
                    :class="rederijLogo(cruise.rederij_naam)"
                ></div>

                <img v-if="euroaanbetaling || campaignaction"  src="https://cdn.cruisereizen.nl/tijdelijk.png" style="width:80px; position: absolute; right:0;">
                <img v-if="discountaction && !showPrice"  src="https://cdn.cruisereizen.nl/Boek-online-100-korting.png" style="width:60px; position: absolute; right:5px; top:5px;">
                <img v-else-if="discountaction && showPrice && activeTotalDiscount > 0"  src="https://cdn.cruisereizen.nl/Boek-online-100-korting.png" style="width:60px; position: absolute; right:5px; top:5px;">


            </div>
            <div class="padding20">
                <div class="font14 bold width100 margintop20 marginbottom30 hideonmobile">
                    <span
                        class="darkblue"
                        v-html="cruise.bestemming_naam + ' Cruise'"
                    ></span
                    ><br />
                    <small class="darkblue font11"
                        >met {{ cruise.schip_naam }}</small
                    >
                </div>
              <div
                  class="width100 marginbottom10 margintop10 font12"
                  style="color: #333;"
              >
                <b>Cruise code:</b> {{ cruise.code }}<br />
                <b>Reisduur:</b> {{ cruise.duur }} dagen <br />
                <span
                ><b>Vertrek:</b>
                        {{ moment(firstDeparture()).format('ll') }}</span
                ><br />
                <span
                ><b>Terugkomst:</b>
                        {{ moment(firstReturn()).format('ll') }}</span
                ><br />

                <b>Aantal:</b>

                <span v-for="(paxType, hutIndex) in payload.cabins">
                        <span v-if="paxType.volwassenen > 0">
                            {{ paxType.volwassenen }} x volwassenen<br
                        /></span>
                        <span v-if="paxType.jeugd > 0">
                            {{ paxType.jeugd }} x jeugdige<span
                            v-if="paxType.jeugd > 1"
                        >n</span
                        ><br
                        /></span>

                        <span v-if="paxType.kinderen > 0">
                            {{ paxType.kinderen }} x kind<span
                            v-if="paxType.kinderen > 1"
                        >eren</span
                        ><br
                        /></span>

                        <span v-if="paxType.baby > 0">
                            {{ paxType.baby }} x baby<span
                            v-if="paxType.baby > 1"
                        >s</span
                        ><br
                        /></span>
                    </span>


              </div>
            </div>
          </div>

          <div class="padding20 bordermobile" style="padding-top:0">
                <div
                    class="width100 marginbottom10  font12"
                    style="color: #333;"
                >
                  <span class="green" ><font-awesome-icon v-if="getRateName(payload.rateCode)" icon="tags" /> {{  getRateName(payload.rateCode) }}</span>
                  <div  v-if="getRateName(payload.rateCode)" class=""></div>
                </div>
            <div
                    class="width100 marginbottom10  font12"
                    style="color: #333;"
                    v-if="coronaactie"
                >
                  <span class="green" ><font-awesome-icon icon="tags" /> Gratis Covid test</span>

                </div>
                <div class="clear width100"></div>

                <!-- cruise overzicht -->
                <div
                    v-on:click="toggleLongView(cruiseView)"
                    class="width100 paddingtop10 bordertopgrey1 pointer darkblue"
                >
                    <b>
                        <font-awesome-icon :icon="cruiseView.icon" />
                        Cruise</b
                    >
                </div>
                <div
                    v-if="cruiseView.shown"
                    :class="{
                        hide: !cruiseView.shown,
                        show: cruiseView.shown,
                    }"
                    class="width100"
                >
                    <span>
                        <b>{{ cruise.itinerary.days[1].haven_naam }}</b>
                        -
                        <b>{{
                            cruise.itinerary.days[cruise.duur].haven_naam
                        }}</b> </span
                    ><br />

                    <span>
                        <b>Vertrek:</b>
                        {{ moment(cruise.begindatum).format('ll') }}
                        {{ cruise.embarktime }} </span
                    ><br />

                    <span>
                        <b>Terugkomst:</b>
                        {{ moment(cruise.terugkeerdatum).format('ll') }}
                        {{ cruise.dissembarktime }} </span
                    ><br />

                    <span v-if="cabin">
                        <b>Huttype:</b>
                        {{ cabinName(cabin.naam, cabin.code) }} </span
                    ><br />

                    <span v-if="cabinNumbers.selected">
                        <b>Hutnummer:</b>
                        {{ displayCabinNumber(cabinNumbers.selected) }}
                    </span>
                </div>
                <div class="clear width100 paddingbottom10"></div>

                <!-- vaarroute -->
                <div
                    v-on:click="toggleLongView(itinView)"
                    class="width100 paddingtop10 bordertopgrey1 pointer darkblue"
                >
                    <b>
                        <font-awesome-icon :icon="itinView.icon" />
                        Vaarroute</b
                    >
                </div>
                <div
                    v-if="itinView.shown"
                    :class="{
                        hide: !itinView.shown,
                        show: itinView.shown,
                    }"
                    class="width100"
                >
                    <div v-for="(port, day) in cruise.itinerary.days">
                        <b>Dag {{ day }}:</b>
                        {{ port.haven_naam }} {{ port.arrival }}
                        {{ port.departure }}
                    </div>
                </div>
                <div class="clear width100 paddingbottom10"></div>

                <!-- vlucht info -->
                <div
                    v-on:click="toggleLongView(flightView)"
                    v-if="flightPrice > 0 && flights"
                    class="width100 paddingtop10 bordertopgrey1 pointer darkblue"
                >
                    <b>
                        <font-awesome-icon :icon="flightView.icon" />
                        Vluchten</b
                    >
                </div>
                <div
                    v-if="flightView.shown && flightPrice > 0 && flights"
                    :class="{
                        hide: !flightView.shown,
                        show: flightView.shown,
                    }"
                    class="width100"
                >
                    <div class="width100">
                        <table>
                            <tr v-if="flights.selectedOutbound">
                                <td width="10%" valign="top">
                                    <font-awesome-icon icon="plane" />
                                </td>
                                <td width="90%">
                                    {{
                                        flights.selectedOutbound
                                            .departureAirport
                                    }}
                                    -
                                    {{ flights.selectedOutbound.arrivalAirport
                                    }}<br />
                                    {{
                                        moment(
                                            flights.selectedOutbound
                                                .departureDate
                                        ).format('llll')
                                    }}
                                </td>
                            </tr>
                            <tr v-if="flights.selectedInbound">
                                <td width="10%" valign="top">
                                    <font-awesome-icon
                                        icon="plane"
                                        flip="horizontal"
                                    />
                                </td>
                                <td width="90%">
                                    {{
                                        flights.selectedInbound.departureAirport
                                    }}
                                    - {{ flights.selectedInbound.arrivalAirport
                                    }}<br />
                                    {{
                                        moment(
                                            flights.selectedInbound
                                                .departureDate
                                        ).format('llll')
                                    }}
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
                <div
                    v-if="flightPrice > 0 && flights"
                    class="clear width100 paddingbottom10"
                ></div>

                <!-- transfer info -->
                <div
                    v-on:click="toggleLongView(transferView)"
                    v-if="
                        transfers.outboundTransfer || transfers.inboundTransfer
                    "
                    class="width100 paddingtop10 bordertopgrey1 pointer darkblue"
                >
                    <b>
                        <font-awesome-icon :icon="transferView.icon" />
                        Transfers</b
                    >
                </div>
                <div
                    v-if="
                        transferView.shown &&
                            (transfers.outboundTransfer ||
                                transfers.inboundTransfer)
                    "
                    :class="{
                        hide: !transferView.shown,
                        show: transferView.shown,
                    }"
                    class="width100"
                >
                    <div class="width100">
                        <table>
                            <tr v-if="transfers.outboundTransfer">
                                <td width="10%" valign="top">
                                    <font-awesome-icon icon="bus" />
                                </td>
                                <td width="90%">
                                    {{
                                        flights.selectedOutbound.arrivalAirport
                                    }}
                                    - Cruiseterminal<br />
                                </td>
                            </tr>
                            <tr v-if="transfers.inboundTransfer">
                                <td width="10%" valign="top">
                                    <font-awesome-icon
                                        icon="bus"
                                        flip="horizontal"
                                    />
                                </td>
                                <td width="90%">
                                    Cruiseterminal -
                                    {{ flights.selectedInbound.departureAirport
                                    }}<br />
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
                <div
                    v-if="
                        transfers.outboundTransfer || transfers.inboundTransfer
                    "
                    class="clear width100 paddingbottom10"
                ></div>

                <!-- price pax specification -->
                <div
                    v-if="cabinPrice > 0"
                    v-on:click="toggleLongView(priceView)"
                    class="width100 paddingtop10 bordertopgrey1 pointer darkblue"
                >
                    <b>
                        <font-awesome-icon :icon="priceView.icon" />
                        Prijzen</b
                    >
                </div>
                <div class="clear width100"></div>

                <div
                    v-if="priceView.shown && cabinPrice > 0"
                    :class="{
                        hide: !priceView.shown,
                        show: priceView.shown,
                    }"
                    class="width100"
                >
                    <span v-if="cabinPrice > 0"><b>Cruise</b></span>

                    <div
                        v-for="(pax, key) in paxInfo.collection"
                        class="width100"
                        v-if="cabinPrice > 0"
                    >
                        <span>
                            <b>{{ key + 1 }}:</b> {{ pax.paxType }}</span
                        >

                        <span
                            v-if="pax.paxType === 'volwassenen'"
                            class="floatright"
                            >€
                            {{
                                roundPrice(
                                    cabin.apiData.prijs /
                                        payload.cabins[0].volwassenen
                                )
                            }}</span
                        >
                        <span v-else="" class="floatright">€ 0,-</span>
                    </div>

                    <div v-if="flightPrice > 0">
                        <br />
                        <div>
                            <span><b>Vluchten</b></span>
                        </div>
                        <div
                            v-for="(pax, key) in paxInfo.collection"
                            class="width100"
                        >
                            <span>
                                <b>{{ key + 1 }}:</b> {{ pax.paxType }}</span
                            >
                            <span class="floatright"
                                >€
                                {{ roundPrice(flightPrice / totalPax) }}</span
                            >
                        </div>
                    </div>

                    <div
                        v-if="
                            transfers.outboundTransfer ||
                                transfers.inboundTransfer
                        "
                    >
                        <br />
                        <div>
                            <span><b>Transfers</b></span>
                        </div>
                        <div
                            v-for="(pax, key) in paxInfo.collection"
                            class="width100"
                        >
                            <span>
                                <b>{{ key + 1 }}:</b> {{ pax.paxType }}</span
                            >
                            <span class="floatright"
                                >€
                                {{ roundPrice(transferPrice / totalPax) }}</span
                            >
                        </div>
                    </div>

                    <div v-if="discount.retrieved && discount.level > 1">
                        <br />
                        <div>
                            <span
                                ><b>{{ discount.description }}</b></span
                            >
                        </div>

                        <div v-if="activeTransferDiscount > 0" class="width100">
                            <span>Transfers</span>
                            <span class="floatright"
                                >€
                                {{ roundPrice(activeTransferDiscount) }}</span
                            >
                        </div>
                        <div v-if="activeFlightDiscount > 0" class="width100">
                            <span>Vluchten</span>
                            <span class="floatright"
                                >€ {{ roundPrice(activeFlightDiscount) }}</span
                            >
                        </div>
                        <div v-if="activeTotalDiscount" class="width100">
                            <span>Totaal</span>
                            <span class="floatright"
                                >€ {{ roundPrice(activeTotalDiscount) }}</span
                            >
                        </div>
                    </div>
                </div>
                <div class="clear width100 paddingbottom10"></div>

                <!-- main price display -->
                <div
                    class="betaalinfo paddingtop10 bordertopgrey1"
                    v-if="totalPrice > 0 && showPrice"
                >

                    <div v-if="new Date() >= new Date('2023-07-13') && cruise.rederij_id === '20' && feePrice > 0" class="width100">
                        <span>Fooien</span>
                        <span class="floatright">€ {{roundPrice(feePrice)}}</span>
                    </div>
                    <div v-if="diningsRecieved && dinings !== null" class="width100">
                      <div v-if="dinings.feesSelected">
                        <span>Fooien</span>
                        <span class="floatright">€ {{roundPrice(dinings.fees)}}</span>
                      </div>
                    </div>
                    <div class="width100">
                        <span>Calamiteitenfonds</span>
                        <span class="floatright">€ 2,50</span>
                    </div>
                    <div class="width100">
                        <span>SGR fonds</span>
                        <span class="floatright">€ {{ roundPrice(sgrCalFondsPrice - 2.5) }}</span>
                    </div>


                    <div v-if="activeTotalDiscount" class="bordertopgrey1">
                        <div
                             class="width100 font14 bold margintop20 "
                        >
                            <span class="darkblue">Subtotaal</span>
                            <span class="floatright font16 darkblue"
                            >€ {{ roundPrice(totalPrice + activeTotalDiscount) }}
                        </span>
                        </div>
                        <div class="width100" style="color: green">
                            <span><b>Korting</b></span>
                            <span class="floatright"><b>- € {{ roundPrice(activeTotalDiscount) }}</b></span>
                        </div>
                    </div>
                    <div
                        class="width100 font20 bold margintop20 marginbottom10"
                    >
                        <span class="darkblue">Totaal</span>
                        <span class="floatright font24 darkblue"
                            >€ {{ roundPrice(totalPrice) }}
                        </span>
                    </div>
                  <div class="width100 marginbottom20"  v-if="cruise.rederij_id === '20' && feePrice > 0 && new Date() < new Date('2023-07-13')">
                    <span style="color: #8a6d40;">Exclusief  &euro;{{ feePrice }} verplichte fooien.</span>

                  </div>
                    <span v-if="payment.type === 'aanbetaling'">
                        <span class="green" style="font-size:14px;">
                            Nu te betalen <b>&euro; {{ roundPrice(payment.amount)
                          }}</b><br />
                        </span>
                        <small>
                            Restantbetaling van &euro;
                            {{ roundPrice(payment.remain) }}<br />
                            te voldoen vóór
                            {{ moment(payment.remainDate).format('ll') }}
                        </small>
                    </span>
                    <span v-else="">
                        <span class="green" style="font-size:14px;"
                            >Nu te betalen: <b>&euro;
                          {{ roundPrice(payment.total) }}</b></span
                        >
                    </span>


                </div>
              <div
                  v-else-if="payload.cabins[0].cabinType && totalPrice > 0"
                  class="width100 font14 bold margintop20 marginbottom20"
              >
                <span class="darkblue">Vanaf</span>
                <span class="floatright font18 darkblue" v-if="lowestRateForCabinType(payload.cabins[0].cabinType).apiData
                          .prijs_cached"
                >
                €
                {{
                  roundPrice(
                      lowestRateForCabinType(payload.cabins[0].cabinType).apiData
                          .prijs_cached / payload.cabins[0].volwassenen
                  )
                }}
                <small v-if="payload.cabins[0].volwassenen > 1">p.p.</small>
                    </span>  <span class="floatright font18 darkblue" v-else
                >
                €
                {{
                  roundPrice(
                      lowestRateForCabinType(payload.cabins[0].cabinType).apiData
                          .prijs / payload.cabins[0].volwassenen
                  )
                }}
                <small v-if="payload.cabins[0].volwassenen > 1">p.p.</small>
                    </span>
                <div class="width100 marginbottom20"  v-if="cruise.rederij_id === '20' && feePrice > 0 && new Date() > new Date('2023-07-13')">
                  <span style="color: #8a6d40;font-size:12px !important;">+  &euro;{{ feePrice }} verplichte fooien.</span>
                </div>
                <div class="width100 marginbottom20"  v-else-if="cruise.rederij_id === '20' && feePrice > 0">
                  <span style="color: #8a6d40;font-size:12px !important;">Exclusief  &euro;{{ feePrice }} verplichte fooien.</span>
                </div>
              </div>
              <div
                  v-else-if="totalPrice > 0"
                  class="width100 font14 bold margintop20 marginbottom20"
              >
                <span class="darkblue">Vanaf</span>
                <span class="floatright font18 darkblue"
                >
                  € {{ roundPrice(totalPrice / payload.cabins[0].volwassenen) }}

                <small v-if="payload.cabins[0].volwassenen > 1">p.p.</small>
                    </span>

                  <div class="width100 marginbottom20" style="font-size:12px!important;"  v-if="cruise.rederij_id === '20' && feePrice > 0 && new Date() < new Date('2023-07-13')">
                      <span style="color: #8a6d40;font-size:12px!important;">Exclusief  &euro;{{ feePrice }} verplichte fooien.</span>
                  </div>

              </div>
                <div
                    v-if="totalPrice === 0 && !availabilityReceived"
                    class="width100 marginbottom10"
                >
                    <center>
                        <font-awesome-icon icon="spinner" :spin="true" />
                       De beste prijzen worden opgehaald...
                    </center>
                </div>
                <div
                    v-if="totalPrice === 0 && availabilityReceived"
                    class="width100 marginbottom10"
                >
                    <center>Kies een hut...</center>
                </div>
            </div>

            <div class="clearfix"></div>
          </div>
            <div v-if="euroaanbetaling" style=" color: green; font-weight: bold;padding:10px;">
              Boek nu met  &euro; 1,- aanbetaling!
            </div>
        </div>

        <div v-if="rivierOnly" class="sidebar-ups">
            <div class="content" style="background: #1F8234">
                <h3 class="title">Daarom RivierCruiseReizen.nl</h3>
                <ul>
                    <li><b>Geen</b> verborgen kosten</li>
                    <li><b>Laagsteprijsgarantie</b></li>
                    <li><b>7 dagen</b> p/w geopend</li>
                    <li>Klantbeoordeling <b>9.8/10</b></li>
                    <li><b>45.506</b> vind-ik-leuks</li>
                    <li><b>ANVR</b>, <b>SGR</b> en <b>CLIA</b> lid</li>
                    <li>Het ruimste aanbod</li>
                </ul>
            </div>
        </div>
        <div v-else class="sidebar-ups">
        <div class="content">
            <h3 class="title">Daarom CruiseReizen.nl</h3>
            <ul>
                <li><b>Geen</b> verborgen kosten</li>
                <li><b>Laagsteprijsgarantie</b></li>
                <li><b>7 dagen</b> p/w geopend</li>
                <li>Klantbeoordeling <b>9.8/10</b></li>
                <li><b>45.506</b> vind-ik-leuks</li>
                <li><b>ANVR</b>, <b>SGR</b> en <b>CLIA</b> lid</li>
                <li>Het ruimste aanbod</li>
            </ul>
        </div>
        </div>
    </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { faMinus, faPlane, faPlus, faChevronUp, faChevronDown } from '@fortawesome/free-solid-svg-icons'

library.add(faPlane)
library.add(faPlus)
library.add(faMinus)
library.add(faChevronUp)
library.add(faChevronDown)

export default {
    name: 'SideBar',
    data: function() {
        return {
            itinView: { shown: false, icon: 'plus' },
            cruiseView: { shown: false, icon: 'plus' },
            flightView: { shown: false, icon: 'plus' },
            priceView: { shown: false, icon: 'plus' },
            transferView: { shown: false, icon: 'plus' },
            isMobile: window.innerWidth < 741,
            mobileShown: false
        }
    },
    props: {
        cruise: Object,
        payload: Object,
        cabin: Object,
        cabinNumbers: Object,
        paxInfo: Object,
        flights: Object,
        feePrice: Number,
        totalPax: Number,
        flightPrice: Number,
        cabinPrice: Number,
        totalPrice: Number,
        dinings: Object,
        diningsRecieved: Boolean,
        sgrCalFondsPrice: Number,
        payment: Object,
        numberWithCommas: Function,
        roundPrice: Function,
        lowestRateForCabinType: Function,
        isGuaranteeCabin: Function,
        cabinName: Function,
        displayCabinNumber: Function,
        availabilityReceived: Boolean,
        transfers: Object,
        transferPrice: Number,
        discount: Object,
        activeTotalDiscount: Number,
        activeFlightDiscount: Number,
        activeTransferDiscount: Number,
        euroaanbetaling: Boolean,
        discountaction: Boolean,
        euroaanbetalingsbedrag: Number,
        coronaactie: Boolean,
        showPrice: Boolean,
      campaignaction: Boolean,

    },
    computed: {
        // Check if riviercruises
        rivierOnly: function() {
            var host = window.location.hostname
            //var host = 'rivier' dev
            return host.includes("rivier");
        },
    },
    methods: {
        firstDeparture: function() {
            let cruiseDeparture = new Date(this.cruise.begindatum)
            if (this.flights && this.flights.selectedOutbound) {
                let flightDeparture = new Date(
                    this.flights.selectedOutbound.departureDate
                )

                if (cruiseDeparture > flightDeparture) return flightDeparture
            }
            return cruiseDeparture
        },
        firstReturn: function() {
            let cruiseReturn = new Date(this.cruise.terugkeerdatum)
            if (this.flights && this.flights.selectedInbound) {
                let flightReturn = new Date(
                    this.flights.selectedInbound.arrivalDate
                )

                if (cruiseReturn > flightReturn) return flightReturn
            }
            return cruiseReturn
        },
        toggleLongView: function(viewItem) {
            if (viewItem.shown) {
                viewItem.shown = false
                viewItem.icon = 'plus'
            } else {
                viewItem.shown = true
                viewItem.icon = 'minus'
            }
        },
        rederijLogo: function(rederij_naam) {
            // remove spaces and convert to lowercase
            return rederij_naam.replace(/\s/g, '').toLowerCase() + 'logo-small'
        },
      getRateName: function(code){
        if (
            this.cruise &&
            this.cruise.ratecode_usps &&
            this.cruise.ratecode_usps.rates
        ) {

          let rateCode = code

          if(this.cruise.rederij_id === '25') {
            rateCode = rateCode.substring(rateCode.length - 3)
          }

          let found = this.cruise.ratecode_usps.rates.filter(function(
              usps
          ) {
            return (
                (usps.rateCode === rateCode) &&
                usps.text !== ''
            )
          })
          if (!found[0]) {
            return code
          }
          return found[0].rateName
        }
        return code
      },
    },
}
</script>

<style scoped lang="scss">
.sidebar-content {
    position: -webkit-sticky;
    position: sticky;
    top: 30px;

    .sidebarHeaderImage {
        border-radius: 5px 5px 0 0;
    }

    .sideBarRederijLogo {
        background-color: #ffffff;
        padding: 0 0 0 5px;
        position: absolute;
        border-radius: 3px;
        top: 5px;
        left: 5px;
    }

    .costacruiseslogo-small {
        background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
        background-position: -1582px -204px;
        width: 42px;
        height: 32px;
    }

    .hollandamericalinelogo-small {
        background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
        background-position: -1170px -162px;
        width: 92px;
        height: 36px;
    }

    .msccruiseslogo-small {
        background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
        background-position: -1274px -166px;
        width: 68px;
        height: 30px;
    }

    .sidebar-ups {
        margin-top: 25px !important;

        .content {
            padding: 20px 15px;
            color: #fff;
            background-color: #2178b3;
        }

        h3 {
            padding: 0;
            margin: 0;
        }

        ul {
            padding: 10px 0 0 20px;
            margin: 0;
        }
    }

  .green{
    color :#2f7000;
  }
}
.blinky .midblock{
  border-color: #afc9da;
  animation: blinkyBackground 2s infinite;
}
@keyframes blinkyBackground {
  10%, 30%, 50%, 70%, 90% {

    background-color: #f3f9fd;
  }
  20%, 40%, 60%, 80%, 100% {
    background:white;
  }
}

@media screen and (max-width: 740px) {
  .clear.width100.paddingbottom10 {
    padding-bottom:0 !important;
  }
  #content {

    .sidebar {
      top:0;
      .midblock {
        width:100% !important;
        margin:0 !important;
      }
    }
  }
  .hideonmobile {
    display: none;
  }
  .showonmobile {
    .margintop20 {
      margin-top:0;
    }

    display: flex !important;
    padding: 0 20px;
    .darkblue {
      font-size:14px;
      &.font11 {
        font-size:12px;
      }
    }
    .width100 {
      padding-top:8px;
      max-width:70%;
    }
  }
  .flexmobile {
    display: flex;

    > div:first-child {
      position: relative;
      width: 50%;
      padding: 10px;

      img {
        border-radius: 5px;
      }

      .sideBarRederijLogo {
        display: none;
      }
    }

    > div:nth-child(2) {
      width: 50%;
      padding: 0 0 0 10px;

      > div {
        margin-top: 0 !important;
        line-height: 18px;
      }
    }

    .padding20 {
      display: flex;
      flex-flow: column;
      justify-content: center;

      .darkblue {
        font-size: 14px;

        &.font11 {
          font-size: 12px;
        }

        .margintop20 {
          margin-top: 10px;
        }
      }

    }
  }
  .sidebar-content .padding20.bordermobile {
    padding-top: 10px;

    > div:first-child {
      border-top: 1px solid #dddddd;
      margin-bottom: 0 !important;
    }
    >
    div:last-child {
      margin-top:0;
      padding-top:0;
    }

    .width100 {
      padding-top: 10px;

    }

    .darkblue {
      font-size: 14px;
    }
  }
  .sidebar-content .midblock {
    display: flex;
    flex-flow: column;
  }
}
</style>
